// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"241":"6561aebb","376":"ea7e94ea","553":"5937540e","854":"367cce39","916":"ced83920","978":"29ff99c6"}[chunkId] + ".css";
};